import { useTranslation } from "react-i18next";
import { SelectFormikField, SelectItem } from "@certn/cascadia-react";
import { useClientPortalAPI } from "@certn/api";

interface Props {
  description?: string;
}

export function SelectLanguageFormikField(props: Props) {
  const { t } = useTranslation();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/order/language-options/"
  );

  return (
    <SelectFormikField
      testID="language-select"
      name="applicant_language"
      isLoading={isLoading}
      description={props.description}
      label={t("Language")}
    >
      {data?.map((language) => {
        return (
          <SelectItem
            id={language.value}
            textValue={language.display_value}
            key={language.value}
          >
            {language.display_value}
          </SelectItem>
        );
      })}
    </SelectFormikField>
  );
}
